/* eslint-disable guard-for-in */
<template>
  <div class="wtv-hero" :class="{
    'wtv-hero-cards': isCards,
  }">
    <Stats v-if="isConfig() && context === 'main' "/>

    <div
      v-for="(cell, i) in initialsList"
      :key="i"
      class="wtv-hero-cell"
      :class="{'wtv-layout': isConfig() }"
    >
      <div v-if="isConfig()" class="wtv-hero-row">
        <div v-if="isLoading(`Getting result ${i}`)" class="wtv-form-control">
          <Loading  code="Getting result" />
        </div>
        <div v-else class="wtv-form-control">
          <div>Мин.цена: {{ cellHotel(i)?.price }}</div>
          <div>Отелей в кеше: {{ cellResult(i)?.hotel?.length }}</div>
        </div>
        <Select
          type="region"
          label="Регион"
          :output="
            cell.regions
              && regionList
              && regionList.find(region => region.id === cell.regions)?.name
          "
          :onSelect="e => setCellRegion(e, i)"
          :options="regionList"
          :selected="cell.regions"
        />
        <Select
          type="subregion"
          label="Курорт"
          :output="
            cell.subregions
              && subRegionList
              && subRegionList.find(region => region.id === cell.subregions)?.name
          "
          :onSelect="e => setCellSubRegion(e, i)"
          :options="
            subRegionList.filter(sub =>
              cell.regions.length > 0
              ? sub.parentregion === cell.regions
              : true)
          "
          :selected="cell.subregions"
        />

        <Input
          v-show="context === 'main'"
          type="text"
          :isTextarea="true"
          label="Описание"
          :value="cell?.text"
          :onInput="e => setCellText(e, i)"
        />

        <div class="wtv-form-control">
          <div
            class="wtv-button-main"
            @click="removeInitial(i)"
            data-stats="open_tour"
          >Удалить</div>
        </div>

        <!-- <Input
          type="image"
          :isTextarea="true"
          label="Имя картинки"
          :value="cell?.text"
          :onInput="e => setCellText(e, i)"
        /> -->
      </div>

      <div v-else-if="!cells[i]?.isHotelListVisible" class="wtv-cell-screen">
        <!-- <img :src="cellHotel(i)?.picturelink" alt=""> -->
        <div class="wtv-cell-content" v-if="cellHotel(i)">
          <div class="wtv-cell-content-row">
            <div class="wtv-cell-content-top">
              <div
                class="wtv-cell-region"
                v-if="regionById(cell.regions)"
              >
                {{regionById(cell.regions).name}}&nbsp;
                <span v-if="subRegionById(cell.subregions)">
                  | {{subRegionById(cell.subregions).name}}
                </span>
              </div>

              <div class="wtv-cell-hotel">
                <span>{{cellHotel(i)?.hotelname?.toLowerCase()}}</span>

                <HotelStars
                  v-if="cellHotel(i)?.hotelstars"
                  :amount="cellHotel(i)?.hotelstars"
                />

              </div>
              <div class="wtv-cell-price">
                {{ cellHotel(i)?.price?.toLocaleString() }}
                <div class="wtv-cell-price-discount" v-if="discount">
                  {{ (Math.floor(cellHotel(i)?.price * (1 + discount)))?.toLocaleString() }}
                </div>
                <span class="wtv-lower">руб.</span>
              </div>
            </div>

            <div
              class="wtv-cell-meta"
              @click="toggleMeta(i)"
            >
              <template v-if="!cells[i]?.isMetaOpen">
                <div
                  class="wtv-cell-meta-item wtv-icon wtv-icon-flydate"
                  data-stats="toggle_meta_flydate">
                  {{ getTour(cellHotel(i)).flydate }}
                </div>
                <div
                  class="wtv-cell-meta-item wtv-icon wtv-icon-nights"
                  data-stats="toggle_meta_nights">
                  {{ getTour(cellHotel(i)).nights }}
                </div>
                <div
                  class="wtv-cell-meta-item wtv-icon wtv-icon-adults"
                  data-stats="toggle_meta_adults">
                  {{ getTour(cellHotel(i)).adults }}
                </div>
              </template>

              <div class="wtv-cell-meta-block" v-else>
                <div class="wtv-cell-meta-row" v-html="getMeta(i)">
                </div>
              </div>

            </div>

          </div>

          <div class="wtv-cell-content-bottom">

            <div class="wtv-cell-content-row">
              <div
                class="wtv-hero-button wtv-button-main wtv-buy"
                @click="openTour(i)"
                data-stats="open_tour"
              >Заказать тур</div>

              <div
                class="wtv-cell-content-row-inner"
                v-if="cellResult(i)?.hotel.length > 1"
              >
                <!-- <div
                  @click="nextCellHotel(i)"
                  data-stats="next_hotel"
                  class="wtv-button-second wtv-next-hotel wtv-icon-after wtv-nowrap"
                >Другой отель</div> -->
                <!-- <div
                  class="wtv-button-second wtv-nowrap"
                  @click="setHotelListVisible(i)"
                  data-stats="open_hotel_list"
                >Все отели ({{ cellResult(i)?.hotel.length }})</div> -->

              </div>
            </div>

            <!-- <div
              class="wtv-cell-content-row wtv-cell-meta"
              @click="toggleMeta(i)"
              v-if="cell?.text"
            >
              <div
                class="wtv-cell-meta-item wtv-icon wtv-icon-text"
                v-if="!cells[i]?.isMetaOpen"
              >
                {{ cell?.text.slice(0, 42) }}...
              </div>
              <div class="wtv-cell-meta-block" v-else>
                <div class="wtv-cell-meta-row">
                  {{ cell?.text }}
                </div>

              </div>
              <div
              class="wtv-icon"
              :class="{
                'wtv-icon-more': !cells[i]?.isMetaOpen,
                'wtv-icon-less': cells[i]?.isMetaOpen,
              }"></div>
            </div> -->
          </div>
          <img :src="getImage(cellHotel(i)?.hotelcode, i)" alt="" class="wtv-hotel-image"/>
        </div>

        <div
          @click="(e) => handleTextLinkClick(event, i)"
          class="wtv-cell-content-text"
          v-if="cell?.text"
          v-html="cell?.text">
        </div>
      </div>

      <div v-else class="wtv-hotel-list-container">
        <div class="wtv-hotel-list-header">
          <div
            class="wtv-cell-region"
            v-if="regionById(cell.regions)"
          >
            {{regionById(cell.regions).name}}&nbsp;
            <span v-if="subRegionById(cell.subregions)">
              | {{subRegionById(cell.subregions).name}}
            </span>
          </div>

          <div
            class="wtv-button-third wtv-hotel-list-back wtv-icon" @click="setHotelListVisible(i)"
            data-stats="close_hotel_list"
          >Назад</div>
        </div>

        <HotelList :list="cellResult(i)?.hotel" :cellIndex="i"  />
      </div>
      <!-- <div v-else class="wtv-hero-cell">
        <h2
          v-if="regionById(cell.regions)"
        >{{regionById(cell.regions).name}}<span
          v-if="subRegionById(cell.subregions)"
        >, {{subRegionById(cell.subregions).name}}</span></h2>

        <h3>{{ cellHotel(i)?.price }} руб</h3>
        <div>Отелей в кеше: {{ cellResult(i)?.hotel.length }}</div>

      </div> -->

    </div>

    <div class="wtv-hero-footer wtv-layout" v-if="isConfig()">

      <div class="wtv-hero-row">
        <div
          class="wtv-button-main"
          @click="addInitial"
          data-stats="open_tour"
        >Добавить регион</div>
      </div>
        <Select
          style="flex: 1"
          type="datepicker"
          label="Даты вылета"
          :output="dateString"
          :df="datefrom"
          :onDateSelect="handleDateSelect"
          :hasSecondDate="true"
          :onSecondDateSelect="handleSecondDateSelect"
        />
      <div class="wtv-hero-row" v-if="context === 'main'">
        <Input
          style="max-width: 200px"
          type="text"
          label="Вылет от, через дней"
          :value="dateFromInDays"
          :onInput="handleDateFromInDaysSelect"
        />
        <Input
          style="max-width: 200px"
          type="text"
          label="Вылет до, через дней"
          :value="dateToInDays"
          :onInput="handleDateToInDaysSelect"
        />
      </div>
      <div class="wtv-form-control">
        <Loading
          code="Saving config"
          v-if="isLoading('Saving config')"
        />
        <div v-else-if="isSaved" class="wtv-form-saved">
          Оно сохранилось!
        </div>
        <div v-else class="wtv-form-submit" @click="handleConfigSave()"
          style="margin-bottom: 8px">Сохранить</div>
        <div
          class="wtv-form-submit"
          @click="handleConfigSave().then(toOrigin)"
        >Сохранить и перейти</div>
      </div>
    </div>
  </div>
</template>
<script lang="ts">

import { defineComponent, computed } from 'vue';
import { useStore } from 'vuex';
import { GATEWAY_FOLDER } from '@/functions';
import Loading from '@/components/Loading.vue';
import Select from '@/components/controls/Select.vue';
import Input from '@/components/controls/Input.vue';
import HotelList from '@/components/HotelList.vue';
import HotelStars from '@/components/HotelStars.vue';
import Stats from '@/components/Stats.vue';

export default defineComponent({
  name: 'Hero',
  components: {
    Select,
    Input,
    Loading,
    HotelList,
    HotelStars,
    Stats,
  },
  setup() {
    const $store = useStore();
    const state = computed(() => $store.state);
    const { context } = $store.getters;
    const cells = computed(() => $store.state.cells);
    const initialsList = computed(() => $store.state.initials.list);
    const regionList = computed(() => $store.state.regionList);
    const subRegionList = computed(() => $store.state.subRegionList);
    const isInitialized = computed(() => $store.state.isInitialized);
    const isSaved = computed(() => $store.state.isSaved);

    const {
      isError, isConfig, isLoading, cellResult,
      cellHotel, regionById, subRegionById, hotelInfo,
    } = $store.getters;

    const nextCellHotel = (index: number) => {
      const e = window.event as Event;
      $store.dispatch('sendStats', {
        cell: initialsList.value[index],
        type: (e.target as HTMLDivElement)?.dataset?.stats,
      });

      const isMaxLength = cellResult(index).hotel.length - 1 === cells.value[index].hotelIndex;
      $store.commit('setCellHotel', {
        index,
        hotelIndex: isMaxLength ? 0 : cells.value[index].hotelIndex + 1,
      });

      const { hotelcode } = cellHotel(index);
      if (!hotelInfo(hotelcode)) {
        $store.dispatch('getHotel', hotelcode);
      }
    };
    const setCellText = (e: Event, i: number) => {
      const { value } = e?.target as HTMLInputElement;
      $store.commit('setCell', {
        param: 'text',
        index: i,
        value,
      });
    };

    const setCellRegion = (e: Event, i: number) => {
      const region: string | undefined = (e?.target as HTMLDivElement).dataset.id;
      $store.commit('setCell', {
        param: 'regions',
        index: i,
        value: region,
      });
      $store.commit('setCell', {
        param: 'subregions',
        index: i,
        value: '',
      });
      if (
        subRegionList.value
          .filter((sub: {parentregion: string}) => sub.parentregion === region)
          .length === 0
      ) {
        $store.dispatch('getCellText', i);
      }
    };

    const setCellSubRegion = (e: Event, i: number) => {
      const subregion: string | undefined = (e?.target as HTMLDivElement).dataset.id;
      $store.commit('setCell', {
        param: 'subregions',
        index: i,
        value: subregion,
      });
      $store.dispatch('getCellText', i);
    };

    // datepicker
    const datefrom = computed(() => new Date($store.state.initials.common.datefrom));
    const dateString = computed(() => `${new Date($store.state.initials.common.datefrom).toLocaleDateString('ru-RU')} - ${new Date($store.state.initials.common.dateto).toLocaleDateString('ru-RU')}`);
    const handleDateSelect = ({ date }: { date: Date }) => {
      const df = new Date(date.setHours(12));
      $store.commit('setCommon', { param: 'datefrom', value: df });
    };
    const handleSecondDateSelect = ({ date }: { date: Date }) => {
      const df = new Date(new Date($store.state.initials.common.datefrom).setHours(12));
      const dt = new Date(date.setHours(12));
      if (df.getTime() < dt.getTime()) {
        $store.commit('setCommon', { param: 'dateto', value: dt });
      } else {
        $store.commit('setCommon', { param: 'datefrom', value: dt });
        $store.commit('setCommon', { param: 'dateto', value: df });
      }
    };

    // dates through days
    const dateFromInDays = computed(() => $store.state.options?.datefromindays);
    const dateToInDays = computed(() => $store.state.options?.datetoindays);
    const handleDateFromInDaysSelect = (e: Event) => {
      const { value } = e?.target as HTMLInputElement;
      $store.commit('setDateFromInDays', value);
      console.log(value);
    };
    const handleDateToInDaysSelect = (e: Event) => {
      const { value } = e?.target as HTMLInputElement;
      $store.commit('setDateToInDays', value);
      console.log(value);
    };

    const handleConfigSave = () => $store.dispatch('saveConfig');
    const handleReload = () => window.location.reload();
    const toOrigin = () => {
      window.location.href = `${window.location.origin}${window.location.pathname}`;
      return false;
    };

    const getImage = (hotelcode: string, i: number) => {
      const cardImages = (window as {WTV_CARD_IMAGES?: string[]}).WTV_CARD_IMAGES;
      if (cardImages) {
        return cardImages[i];
      }
      const imageList = hotelInfo(hotelcode)?.images?.image;
      if (!imageList || imageList.length === 0) return `${GATEWAY_FOLDER}assets/loading.webp`;

      return imageList[0];
    };
    const setHotelListVisible = (index: number) => {
      const e = window.event as Event;
      $store.dispatch('sendStats', {
        cell: initialsList.value[index],
        type: (e.target as HTMLDivElement)?.dataset?.stats,
      });
      const isHotelListVisible = !state.value.cells[index].isHotelListVisible;
      $store.commit('setCellHotel', { index, isHotelListVisible });
    };

    const getTour = (hotel: { tours: { tour: unknown[] }} | false) => {
      if (!hotel || !hotel.tours || !hotel.tours.tour) return false;

      return hotel.tours.tour[0];
    };

    const openTour = (i: number) => {
      const e = window.event as Event;
      $store.dispatch('sendStats', {
        cell: initialsList.value[i],
        type: (e.target as HTMLDivElement)?.dataset?.stats,
      });

      const hotel = cellHotel(i);
      const { hotelcode } = hotel;
      const tour = getTour(hotel);
      const list = cellResult(i)?.hotel;
      if (!hotelInfo(hotelcode)) {
        $store.dispatch('getHotel', hotelcode);
      }
      $store.dispatch('actualize', tour);
      $store.commit('setRelatedList', list);
      $store.commit('setCellIndex', i);
    };

    const toggleMeta = (index: number) => {
      const e = window.event as Event;
      const type = (e.target as HTMLDivElement)?.dataset?.stats;
      if (type) {
        $store.dispatch('sendStats', {
          cell: initialsList.value[index],
          type,
        });
      }

      const isMetaOpen = !state.value.cells[index].isMetaOpen;
      $store.commit('setCellHotel', { index, isMetaOpen });
    };
    const getMeta = (index: number) => {
      const tour = getTour(cellHotel(index)) as {
        flydate: string;
        adults: string;
        nights: string;
        mealrussian: string;
        room: string;
      };
      return `
Начало тура: ${tour.flydate},
${tour.adults}&nbsp;взрослых,
${tour.nights}&nbsp;ночей,
${tour.mealrussian},
${tour.room}`;
    };
    const crElem = (
      type: string,
      parent: HTMLElement,
      innerHTML = '',
      attrObj: {[key: string]: string} = {},
    ) => {
      const elt = document.createElement(type);
      if (Object.keys(attrObj).length !== 0) {
        Object.keys(attrObj).forEach((attr) => elt.setAttribute(attr, attrObj[attr]));
        // for (const attr in attrObj) elt.setAttribute(attr, attrObj[attr]);
      }
      elt.innerHTML = innerHTML != null ? innerHTML : '';
      parent.appendChild(elt);
      return elt;
    };

    const handleTextLinkClick = (e = window.event, i: number) => {
      const text = (e?.target as HTMLElement)?.dataset.text;
      if (!text) return;

      $store.dispatch('sendStats', {
        cell: initialsList.value[i],
        type: 'open_text_link',
      });

      (e as Event).stopPropagation();
      (e as Event).preventDefault();

      const container = e?.target as HTMLElement;
      if (container) {
        container.removeAttribute('href');
        if (container.firstElementChild) {
          container.firstElementChild.remove();
        }
        const popup = crElem('div', container, text, { class: 'wtv-link-description' });

        const removePopup = () => {
          (e as Event).stopPropagation();
          (e as Event).preventDefault();
          window.removeEventListener('click', removePopup);
          return (popup as HTMLElement)?.remove();
        };
        window.addEventListener('click', removePopup);
      }
    };

    const removeInitial = (i: number) => $store.commit('removeInitial', i);
    const addInitial = () => $store.commit('addInitial');

    const isCards = computed(() => (window as {WTV_IS_CARDS?: boolean}).WTV_IS_CARDS);

    Object.assign(window, {
      getCacheForHotel: (hotelcode: number) => $store.dispatch('getCache', {
        ...state.value.initials.common,
        hotels: hotelcode,
      }),
    });
    document.dispatchEvent(new Event('getCacheForHotelReady'));
    const discount = computed(() => (window as {WTV_DISCOUNT?: number}).WTV_DISCOUNT || 0);

    cells.value.map((c: unknown) => console.log(c));

    return {
      context,
      state,
      initialsList,
      regionList,
      subRegionList,
      cells,
      isInitialized,
      isError,
      isLoading,
      isConfig,
      isSaved,
      cellResult,
      cellHotel,
      nextCellHotel,
      regionById,
      subRegionById,

      setCellText,
      setCellRegion,
      setCellSubRegion,
      handleConfigSave,
      handleReload,
      toOrigin,

      datefrom,
      dateString,
      handleDateSelect,
      handleSecondDateSelect,

      dateFromInDays,
      dateToInDays,
      handleDateFromInDaysSelect,
      handleDateToInDaysSelect,

      getImage,
      setHotelListVisible,
      toggleMeta,
      getMeta,
      getTour,

      openTour,

      handleTextLinkClick,

      removeInitial,
      addInitial,
      isCards,
      discount,
    };
  },
});
</script>
<style scoped>

 /* cards */

 .wtv-hero-cards.wtv-hero {
    flex-direction: row;
    flex-wrap: nowrap;
    padding: 1rem;
  }

  .wtv-hero-cards .wtv-hero-cell {
    flex: 1 0 16%;
    margin: 2px;
    max-width: calc(100% - 4px);
  }
  .wtv-hero-cards .wtv-cell-content-row,
  .wtv-hero-cards .wtv-cell-content-row-inner {
    flex-direction: column;
  }
  .wtv-hero-cards .wtv-cell-content-text {
    display:none;
  }
  .wtv-hero-cards .wtv-cell-screen {
    padding: 0.2rem;
  }
  .wtv-hero-cards img {
    border-radius: 4px;
    overflow: hidden;
    box-shadow: 0 0 1rem #0004,  0 0.2rem 0.2rem #0002;
  }
  @media(max-width: 1366px){
    .wtv-hero-cards.wtv-hero {
      flex-wrap: wrap;
      padding: 1rem;
    }
  }

 /* default */

  .wtv-hero-cell {
    flex: 1 0 40%;
    margin: 2px;
    max-width: calc(100% - 4px);
    min-width: 200px;
  }

  .wtv-hero-cell.wtv-layout {
    padding: 8px;
  }
  .wtv-hero-footer {
    display: flex;
    justify-content: center;
    flex: 2 0 80%;
    margin: 2px;
    padding: 8px;
  }
  .wtv-hero {
    width: 100%;
    display: flex;
    flex-flow: row wrap;
  }

  .wtv-hero-row {
    display: flex;
    flex-flow: row wrap;
  }
  .wtv-cell-screen,
  .wtv-hotel-list-container {
    width: 100%;
    min-height: 420px;
    /* overflow: hidden; */
    position: relative;
    display: flex;
  }
  .wtv-cell-screen {
    flex-direction: column;
  }
  .wtv-hotel-list-container {
    flex-direction: column;
    padding: 4px 0;
  }
  .wtv-hotel-list-header {
    display: flex;
    padding: 0 8px;
    justify-content: space-between;
    border-top: 1px solid var(--color-text);
    padding-top: 4px;
  }
  .wtv-hotel-list-back {
    margin-right: 4px;
    margin-top: 0;
    margin-bottom: 4px;
  }
  .wtv-hotel-list-back::before {
    content: '\f053';
    margin-right: 4px;
  }
  .wtv-hotel-image {
    margin: -4px -18px;
    width: calc(100% + 36px);
    height:  calc(100% + 8px);
    top: 0;
    position: absolute;
    z-index: 0;
    object-fit: cover;
    max-width: unset;
  }
  .wtv-cell-content {
    margin: 4px 18px;
    display: flex;
    flex: 1;
    flex-direction: column;
    justify-content: space-between;
  }
  @media (max-width: 575px) {
    .wtv-cell-content {
      min-height: 420px;
    }
  }
  .wtv-cell-content-text {
    background-color: var(--color-bg);
    /* z-index: 2; */
    flex: 0;
    padding: 12px 18px 24px;
  }
  .wtv-cell-content,
  .wtv-cell-content-top {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    position: relative;
    z-index: 1;
  }
  .wtv-cell-content-top {

    margin-right: 4px;
  }
  .wtv-cell-content-bottom {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    position: relative;
    z-index: 1;
    margin-bottom: 12px;
    width: 100%;
  }
  .wtv-cell-content-row {
    flex-wrap: wrap;
  }
  .wtv-cell-content-row,
  .wtv-cell-content-row-inner {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    width: 100%;
  }
  .wtv-cell-content-row-inner {
    width: unset;
  }
  .wtv-cell-price {
    padding: 2px 4px 3px;
    display: inline-flex;
    align-items: flex-end;
    background: var(--color-main);
    line-height: 1.2em;
    font-size: 26px;
    font-weight: 700;
    color: var(--color-paper);
    margin: 2px 0;
  }
  .wtv-cell-price .wtv-lower {
    padding-left: 8px;
    line-height: 1.4em;
    color: var(--color-alt);
  }
  .wtv-cell-price-discount {
    margin-left: 0.5rem;
    text-decoration: line-through;
    font-size: 1rem;
    opacity: 0.7;
    font-weight: normal;
  }
  .wtv-cell-hotel {
    padding: 2px 4px 3px;
    display: inline-flex;
    flex-wrap: wrap;
    margin: 2px 0;
    font-size: 15px;
    font-weight: 600;
    text-transform: capitalize;
    color: var(--color-third);
    background-color: var(--color-text);
  }
  .wtv-cell-region {
    padding: 2px 4px 3px;
    display: inline-flex;
    flex-wrap: wrap;
    margin: 2px 0;
    font-size: 18px;
    background-color: var(--color-paper);
    /* text-shadow: 0 0 1px var(--color-bg), 0 0 8px var(--color-bg-dark),
    1px 0 12px var(--color-bg); */
  }
  .wtv-hero-button {
    font-size: 18px;
    width: unset;
    box-shadow: 0 0 1px var(--color-text), 0 0 8px var(--color-text-5),
    1px 0 12px var(--color-text-5);
    margin-right: 4px;
  }

  @media (max-width: 1366px) {
    .wtv-cell-price {
      font-size: 22px;
    }
    .wtv-cell-hotel {
      font-size: 14px;
    }
    .wtv-cell-region {
      font-size: 16px;
      font-weight: 600;
    }
    .wtv-hero-button {
      font-size: 15px;
    }
  }

  .wtv-hero-button:hover {
    box-shadow: 0 0 1px var(--color-second-alt), 0 0 8px var(--color-second-alt),
    1px 0 12px var(--color-second);
  }
  .wtv-next-hotel {
    margin-right: 4px;
  }
  .wtv-next-hotel::after {
    content: '\f105';
    font-size: 18px;
    margin-left: 4px;
  }

  .wtv-cell-meta {
    display: flex;
    flex: 1 0 50%;
    /* align-items: center; */
    justify-content: flex-end;
    flex-wrap: wrap;
    padding-top: 2px;
    cursor: pointer;
    z-index: 1;
  }
  @media (max-width: 575px) {
    .wtv-cell-meta {
      justify-content: flex-start;
    }
  }
  .wtv-cell-meta-item {
    padding: 3px 12px 3px;
    margin-right: 4px;
    margin-bottom: 4px;
    background-color: var(--color-paper);
    border-radius: 12px;
    font-size: 15px;
    font-weight: 600;
  }
  .wtv-cell-meta-item::before {
    margin-right: 4px;
    color: var(--color-alt-5);
  }
  .wtv-cell-meta-item:last-child {
    margin-right: unset;
  }
  .wtv-cell-meta-block {
    margin-right: 4px;
    margin-bottom: 4px;
    background-color: var(--color-paper);
  }
  .wtv-cell-meta-row {

    padding: 4px;
  }
  .wtv-cell-meta-row:nth-child(2n + 1) {
    background-color: var(--color-bg);
  }

  .wtv-form-saved {
    height: 52px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  /* icons */
  /* .wtv-icon-more {
    margin-bottom: 4px;
    margin-right: 4px;
  }
  .wtv-icon-more::before {
    content: '\f13a';
    font-size: 24px;
    color: var(--color-paper);
  }
  .wtv-icon-adults::before {
    content: '\f2bd';
  }
  .wtv-icon-nights::before {
    content: '\f186';
  }
  .wtv-cell-meta-item.wtv-icon::before {
    color: var(--color-third);
  } */

</style>
